import React from "react";
import PropTypes from "prop-types";
import { EMAIL, NAME } from "APP_ROOT/constants";

export default function Contact({ contact }) {
  return (
    <table className="table table-condensed">
      <tbody>
        <tr>
          <th className="text-right">Contact</th>
          <td>{contact && contact.get(NAME)}</td>
        </tr>
        <tr>
          <th className="text-right">Contact Email</th>
          <td>
            <a href={`mailto:${contact && contact.get(EMAIL)}`}>
              {contact && contact.get(EMAIL)}
            </a>
          </td>
        </tr>
      </tbody>
    </table>
  );
}

Contact.propTypes = {
  contact: PropTypes.instanceOf(Object)
};



// WEBPACK FOOTER //
// ./app/modules/Orders/shared/Contact.jsx